import http from "src/services/http";
import queryString from "query-string";
import store from "src/store";
import * as types from "../types/entregadores";

export const excluirEntregador = (id) => {
  const { filtro } = store.getState().entregadores;
  store.dispatch({ type: types.SET_LOADING_ENTREGADOR, payload: true });
  return http.delete(`/api/v2/empresa/entregadores/${id}`).then(
    (response) => store.dispatch(pesquisarEntregadores(filtro)),
    (error) => {
      console.log(error);
      store.dispatch({ type: types.SET_LOADING_ENTREGADOR, payload: false });
    }
  );
};

export const cadastrar = (entregador) => {
  const { filtro } = store.getState().entregadores;
  store.dispatch({ type: types.SET_LOADING_ENTREGADOR, payload: true });
  return http.post(`/api/v2/empresa/entregadores`, entregador).then(
    () => {
      store.dispatch(pesquisarEntregadores(filtro));
    },
    (e) => {
      store.dispatch([{ type: types.SET_LOADING_ENTREGADOR, payload: false }]);
    }
  );
};

export const pesquisarEntregadores = (filtro) => {
  const qry = queryString.stringify(filtro, { arrayFormat: "index" });
  store.dispatch({ type: types.SET_LOADING_ENTREGADOR, payload: true });
  return (dispatch) => {
    http.get(`/api/v2/empresa/entregadores?${qry}`).then(
      (response) => {
        const { total, data } = response.data;
        dispatch([
          { type: types.SET_ENTREGADORES_TOTAL, payload: total },
          { type: types.SET_ENTREGADORES, payload: data },
          { type: types.SET_LOADING_ENTREGADOR, payload: false },
        ]);
      },
      (_) => {
        dispatch([{ type: types.SET_LOADING_ENTREGADOR, payload: false }]);
      }
    );
  };
};
